/// <amd-module name="SuiteCommerce.CookieConsent.Modal.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.CookieConsent.Modal.View", ["require", "exports", "Backbone", "suitecommerce_cookie_consent_modal.tpl", "SuiteCommerce.CookieConsent.Modal.Configuration"], function (require, exports, Backbone_1, template, Modal_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ModalView = /** @class */ (function (_super) {
        __extends(ModalView, _super);
        function ModalView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.template = template;
            _this.events = {
                'click [data-action="toggleThirdPartiesButton"]': 'toggleThirdPartiesButton',
                'click [data-action="toggleAnalyticsButton"]': 'toggleAnalyticsButton',
                'click [data-action="acceptAllCookies"]': 'setAllPreferencesToTrue',
                'click [data-action="rejectAllCookies"]': 'setAllPreferencesToFalse'
            };
            return _this;
        }
        ModalView.prototype.toggleThirdPartiesButton = function () {
            this.model.setThirdPartiesCookie(!this.model.thirdPartiesCookie);
        };
        ModalView.prototype.toggleAnalyticsButton = function () {
            this.model.setAnalyticsCookie(!this.model.analyticsCookie);
        };
        ModalView.prototype.setAllPreferencesToTrue = function () {
            var analyticsButton = jQuery('#analyticsButton');
            if (!analyticsButton.hasClass('active')) {
                analyticsButton.trigger('click');
            }
            var thirdPartiesButton = jQuery('#thirdPartiesButton');
            if (!thirdPartiesButton.hasClass('active')) {
                thirdPartiesButton.trigger('click');
            }
        };
        ModalView.prototype.setAllPreferencesToFalse = function () {
            var analyticsButton = jQuery('#analyticsButton');
            if (analyticsButton && analyticsButton.hasClass('active')) {
                analyticsButton.trigger('click');
            }
            var thirdPartiesButton = jQuery('#thirdPartiesButton');
            if (thirdPartiesButton && thirdPartiesButton.hasClass('active')) {
                thirdPartiesButton.trigger('click');
            }
        };
        ModalView.prototype.getContext = function () {
            return {
                cookiesShortText: Modal_Configuration_1.ModalConfiguration.cookieSettingsShortText,
                strictlyNecessaryText: Modal_Configuration_1.ModalConfiguration.strictlyNecessaryCookiesText,
                analyticsText: Modal_Configuration_1.ModalConfiguration.analyticsCookiesText,
                thirdPartyText: Modal_Configuration_1.ModalConfiguration.thirdPartyCookiesText,
                analyticsCookieState: this.model.analyticsCookie,
                thirdPartyCookieState: this.model.thirdPartiesCookie
            };
        };
        return ModalView;
    }(Backbone_1.View));
    exports.ModalView = ModalView;
});
